import { apiClient } from "./apiClient";
import { User } from "../models/User";

export const getSelf = () => apiClient.get("/user/self").then(res => res.data);

export const update = (user: Partial<User>) =>
  apiClient.patch("/user/update", user).then(res => res.data);
